import React from 'react';
import css from './crossedPrice.module.scss';
import Rub from '../ui/Rub';

const CrossedPrice = ({ price }) => (
    <span className={css.crossedPrice}>
        <span className={css.crossedPriceLine} />
        <span className={css.crossedPriceText}>{price}</span>
        <span className={css.crossedPriceText} style={{ fontWeight: 600 }}>
            <Rub />
        </span>
    </span>
);


export default CrossedPrice;
